/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowShapeADownRightIcon16Solid = forwardRef('ArrowShapeADownRightIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M3.465 14H12a2 2 0 0 0 2-2V3.466c0-1.025-1.24-1.538-1.964-.814l-1.85 1.85-2.7-2.7a1.75 1.75 0 0 0-2.474 0l-3.21 3.21a1.75 1.75 0 0 0 0 2.475l2.7 2.7-1.85 1.85C1.927 12.76 2.44 14 3.465 14Z" })));
});
